export const BASKET_PREVIEW = 'preview' as const;
export const BASKET_INFOS = 'infos' as const;
export const BASKET_PAYMENT = 'payment' as const;

export type PaymentStep = typeof BASKET_PREVIEW | typeof BASKET_INFOS | typeof BASKET_PAYMENT | null;
